import React from "react";
import BusinessTimingPreviewCard from "./BusinessTimingPreviewCard";
import { Box, Button, Stack, Typography, useMediaQuery } from "@mui/material";
import DeliveryMethodsPreviewCard from "./DeliveryMethodsPreviewCard";
import DiscountPreviewCard from "./DiscountPreviewCard";
import BankDetailsPreviewCard from "./BankDetailsPreviewCard";
import OtherDetailsPreviewCard from "./OtherDetailsPreviewCard";
import ActionButtons from "../../../components/Buttons/ActionButtons";
import {
  blackColor,
  blackShade22,
  blueColor04,
  greyShade08,
  mobilePrimary,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { stickyHeader } from "../../../utils/styles";

function CommerceInfoPreview({ data, onSubmit, onBack, handleCancel, type }) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const {
    businessTiming,
    addressInfo,
    deliveryMethods,
    discountInfo,
    otherDetails,
  } = data;
  const {
    costBoDelivery,
    costBoHyperlocal,
    isCOD,
    cod,
    fullfillment,
    fullfillmentPricing,
    b2bDelivery,
    storePickup,
  } = deliveryMethods;
  return (
    <Box pb={1.2}>
      <Box sx={{ ...stickyHeader, pt: 0 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: "center", md: "start" }}
        >
          <Typography
            component="h6"
            fontSize={{ xs: 15, md: 17 }}
            color={blackColor}
            fontWeight={600}
            lineHeight="20px"
            pb={"12px !important"}
            sx={stickyHeader}
          >
            <span
              style={{
                color: matches ? blueColor04 : mobilePrimary,
                marginRight: "5px",
              }}
            >
              Preview -
            </span>
            E-Commerce Details
          </Typography>
          <Stack gap={0.5} alignItems="flex-end" py={{ md: 1, xs: 0 }}>
            <Button
              sx={styles.saveBtn}
              variant="contained"
              disableElevation
              onClick={onSubmit}
              // startIcon={<CircularProgress size={14} sx={{color: blackShade159}} />}
            >
              SUBMIT
            </Button>
            {matches && (
              <Typography fontSize={12} color={greyShade08}>
                Please review the information below before proceeding
              </Typography>
            )}
          </Stack>
        </Box>
        {!matches && (
          <Typography fontSize={12} color={greyShade08}>
            Please review the information below before proceeding
          </Typography>
        )}
      </Box>

      <BusinessTimingPreviewCard data={businessTiming} />
      <DeliveryMethodsPreviewCard
        costBoDelivery={costBoDelivery}
        costBoHyperlocal={costBoHyperlocal}
        isCOD={isCOD}
        cod={cod}
        fullfillment={fullfillment}
        fullfillmentPricing={fullfillmentPricing}
        b2bDelivery={b2bDelivery}
        storePickup={storePickup}
      />
      <DiscountPreviewCard data={discountInfo} />
      {/* <BankDetailsPreviewCard /> */}
      <OtherDetailsPreviewCard data={otherDetails} />

      <Box mt="20px">
        <ActionButtons
          backBtnText="Previous"
          saveBtnText="SUBMIT"
          onBackClick={onBack}
          onSaveClick={onSubmit}
          onCancelClick={handleCancel}
          showBackBtn
          hideNextBtn
        />
      </Box>
    </Box>
  );
}

export default CommerceInfoPreview;

const styles = {
  saveBtn: {
    backgroundColor: { xs: whiteColor, md: blackShade22 },
    padding: { md: "4px 14px", xs: "3px 6px" },
    fontSize: "12px",
    fontWeight: 500,
    color: { xs: mobilePrimary, md: whiteColor },
    border: {
      xs: "1.5px solid " + mobilePrimary,
      md: "1.5px solid " + blackShade22,
    },
    // width: "75px", // Ensures button width is only as wide as its content
    maxWidth: "fit-content", // Prevents unnecessary expansion
    display: "inline-block", // Keeps button as a self-contained element
    "&:hover": {
      color: { xs: mobilePrimary, md: blackShade22 },
      backgroundColor: { xs: mobilePrimary, md: whiteColor },
    },
  },
};
